<div class="content-select">
  <h1>
    {{'SEAT_MAP_MODULE.CHOOSE_THE_FLIGHT'|transloco}}
  </h1>
  <div class="content-box">
    <ng-container *ngIf="itineraryDetail">
      <div class="box-item" *ngFor="let sector of itineraryDetail.Sectors">
        <input [id]="'radio'+sector.SectorNumber" type="radio" [attr.name]="flightItemGroupId(sector)"
          [checked]="sector.IsSelected" (click)="selectSelectorItinerary(itineraryDetail,sector.SectorNumber)">
        <label
          [attr.for]="'radio'+sector.SectorNumber">{{sector.Flights[0]?.DepartureDate| date: 'EEEE, d MMM yyyy' | dateFormat|titlecase}}</label>
      </div>
    </ng-container>
  </div>
</div>